/* tslint:disable */
import {
  executeRequest,
  executeStaticRequest
} from './http-client'
import {
  hostsConfig,
  turnToConfig
} from 'init/config'

export interface Answer {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number,
  'replyToken' ? : string,
  'expertLabel' ? : string,
  'isStaff' ? : boolean,
  'isIndependentExpert' ? : boolean,
  'multiItems' ? : Array < CatalogItem > ,
    'thanked' ? : boolean,
    'syndicationSourceSiteName' ? : string,
    'syndicationSourceSiteId' ? : number,
    'purchaseDateFormatted' ? : string,
    'purchaseDateMillis' ? : number,
    'replies' ? : Array < Reply >
}
export interface AnswerInitData {
  'answerer' ? : User,
  'question' ? : Question,
  'token' ? : string,
  'userData' ? : string
}
export interface AddVideoLinkResponse {
  'authorUrl' ? : string,
  'authorName' ? : string,
  'height' ? : number,
  'html' ? : string,
  'provider' ? : string,
  'providerId' ? : string,
  'providedLink' ? : string,
  'thumbnailUrl' ? : string,
  'thumbnailWidth' ? : number,
  'thumbnailHeight' ? : number,
  'timeRetrieved' ? : number,
  'width' ? : number
}
export interface Article {
  'id' ? : number,
  'title' ? : string,
  'text' ? : string
}
export interface CatalogItem {
  'id' ? : number,
  'title' ? : string,
  'imageId' ? : number,
  'imageProcessed' ? : boolean,
  'type' ? : number,
  'url' ? : string,
  'sku' ? : string,
  'attributes' ? : Array < {
    'label' ? : string,
    'value' ? : string
  } >
}
export interface CreateCommentBody {
  'email' ? : string,
  'siteCatalogItemId' ? : number,
  'siteUserId' ? : number,
  'transactionItemId': number,
  'text': string
}
export interface CreateMediaItemsBody {
  'media' ? : Array < MediaForSave > ,
    'catItemId' ? : number
}
export interface MediaForSave {
  'caption' ? : string,
  'height' ? : number,
  'width' ? : number,
  'type' ? : 0 | 1,
    'imageId' ? : string,
    'imageType' ? : string,
    'orientation' ? : number,
    'authorUrl' ? : string,
    'authorName' ? : string,
    'durationMillis' ? : number,
    'html' ? : string,
    'provider' ? : string,
    'providerId' ? : string,
    'providedLink' ? : string,
    'thumbnailUrl' ? : string,
    'thumbnailWidth' ? : number,
    'thumbnailHeight' ? : number,
    'timeRetrieved' ? : number
}
export interface ChatterCommentsResponse {
  'total' ? : number,
  'comments' ? : Array < Comment >
}
export interface CommentsPinboardItem {
  'id' ? : number,
  'title' ? : string,
  'imageId' ? : number,
  'imageProcessed' ? : boolean,
  'type' ? : number,
  'url' ? : string,
  'sku' ? : string,
  'attributes' ? : Array < {
      'label' ? : string,
      'value' ? : string
    } > ,
    'averageRating' ? : number,
    'reviewCount' ? : number,
    'commentsCount' ? : number,
    'comments' ? : Array < Comment >
}
export interface CreateAnswerBody {
  'catItemId': number,
  'questionId': number,
  'text': string,
  'itemQuestionRecipientLogId' ? : number,
  'multiItemIds' ? : Array < number > ,
    'sourceId' ? : 1 | 2
}
export interface CreateReplyBody {
  'answerId': number,
  'catItemId': number,
  'parentReplyId' ? : number,
  'text': string
}
export interface CreateQuestionBody {
  'text': string,
  'questionType': number,
  'multiItemIds' ? : Array < number >
}
export interface CreateTransactionBody {
  'orderId' ? : string,
  'deliveryDate' ? : string,
  'email' ? : string,
  'emailOptOut' ? : boolean,
  'externalUserId' ? : string,
  'firstName' ? : string,
  'lastName' ? : string,
  'nickName' ? : string,
  'postalCode' ? : string,
  'items' ? : Array < CreateTransactionLineItem >
}
export interface CreateTransactionLineItem {
  'lineItemId' ? : string,
  'itemImageUrl' ? : string,
  'price' ? : string,
  'siteKey' ? : string,
  'sku' ? : string,
  'title' ? : string,
  'url' ? : string
}
export interface CreateUserIdentityBody {
  'email' ? : string,
  'isPrimary' ? : boolean
}
export interface CreateUserIdentityResponse {
  'total' ? : number,
  'identities' ? : Array < UserIdentity >
}
export interface DeleteUserIdentityResponse {
  'total' ? : number,
  'identities' ? : Array < UserIdentity >
}
export interface DoMoreCatalogItem {
  'id' ? : number,
  'title' ? : string,
  'imageId' ? : number,
  'imageProcessed' ? : boolean,
  'type' ? : number,
  'url' ? : string,
  'sku' ? : string,
  'attributes' ? : Array < {
      'label' ? : string,
      'value' ? : string
    } > ,
    'unreviewedPurchase' ? : boolean,
    'questions' ? : Array < Question >
}
export interface GetCatalogItemsForCommentsPinboardResponse {
  'hasMore' ? : boolean,
  'catalogItems' ? : Array < CommentsPinboardItem >
}
export interface GetCatalogItemsResponse {
  'totalFound' ? : number,
  'items' ? : Array < CatalogItem >
}
export interface GetDoMoreContentResponse {
  'answerer' ? : User,
  'catItems' ? : Array < DoMoreCatalogItem > ,
    'total' ? : number,
    'token' ? : string,
    'userData' ? : string
}
export interface GetUserAnswersResponse {
  'answers' ? : Array < Answer > ,
    'total' ? : number
}
export interface GetUserCommentsResponse {
  'comments' ? : Array < Comment > ,
    'total' ? : number
}
export interface GetUserIdentitiesResponse {
  'identities' ? : Array < UserIdentity >
}
export interface GetUserMediaResponse {
  'media' ? : Array < Media > ,
    'total' ? : number
}
export interface GetUserQuestionsResponse {
  'questions' ? : Array < Question > ,
    'total' ? : number
}
export interface GetUserReviewsResponse {
  'reviews' ? : Array < Review > ,
    'total' ? : number
}
export interface Comment {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number
}
export interface SearchResult {
  'id' ? : number,
  'ugcType' ? : "q" | "ir" | "k",
  'text' ? : string,
  'itemTitle' ? : string,
  'title' ? : string,
  'rating' ? : number,
  'answerCount' ? : number
}
export interface SearchBody {
  'catalogItemId' ? : number,
  'includeRelatedQuestions' ? : boolean,
  'includeRelatedReviews' ? : boolean,
  'searchTerm' ? : string,
  'sku' ? : string,
  'brand' ? : string,
  'categoryIds' ? : Array < number > ,
    'isCategory' ? : boolean
}
export interface SearchResponse {
  'total' ? : number,
  'items' ? : Array < SearchResult >
}
export interface Media {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number,
  'catItems' ? : Array < CatalogItem > ,
    'type' ? : 0 | 1,
    'width' ? : number,
    'height' ? : number,
    'imageId' ? : string,
    'imageProcessed' ? : boolean,
    'imageType' ? : string,
    'orientation' ? : number,
    'durationMillis' ? : number,
    'durationFormatted' ? : string,
    'thumbnailUrl' ? : string,
    'thumbnailWidth' ? : number,
    'thumbnailHeight' ? : number,
    'html' ? : string,
    'upVotes' ? : number
}
export interface MediaInitData {
  'catItem' ? : CatalogItem,
  'token' ? : string,
  'userData' ? : string
}
export interface MediaListResponse {
  'total' ? : number,
  'media' ? : Array < Media >
}
export interface MediaSize {
  'containerWidth' ? : number,
  'mediaSize' ? : number
}
export interface MediaUploadResponse {
  'uploadId' ? : string,
  'imageId' ? : string,
  'imageType' ? : string,
  'width' ? : number,
  'height' ? : number,
  'orientation' ? : number
}
export interface Question {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number,
  'answerToken' ? : string,
  'isStaff' ? : boolean,
  'multiItems' ? : Array < CatalogItem > ,
    'upVotes' ? : number,
    'syndicationSourceSiteName' ? : string,
    'syndicationSourceSiteId' ? : string,
    'answers' ? : Array < Answer >
}
export interface QuestionsListResponse {
  'brand' ? : string,
  'catalogItemId' ? : number,
  'parentCategoryIds' ? : Array < number > ,
    'total' ? : number,
    'questions' ? : Array < Question >
}
export interface RelatedQuestion {
  'catItemId' ? : number,
  'isAutoadd' ? : boolean,
  'relationshipType' ? : string,
  'relatedQuestion' ? : Array < Question >
}
export interface RelatedQuestionsListResponse {
  'total' ? : number,
  'relatedQuestions' ? : Array < RelatedQuestion >
}
export interface Reply {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number,
  'replyToken' ? : string,
  'expertLabel' ? : string,
  'isStaff' ? : boolean,
  'isIndependentExpert' ? : boolean,
  'syndicationSourceSiteName' ? : string,
  'syndicationSourceSiteId' ? : string,
  'replies' ? : Array < Reply >
}
export interface ReplyInitData {
  'replier' ? : User,
  'question' ? : Question,
  'parentReplyId' ? : number,
  'token' ? : string,
  'userData' ? : string
}
export interface Review {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number,
  'rating' ? : number,
  'title' ? : string,
  'upVotes' ? : number,
  'downVotes' ? : number,
  'expertLabel' ? : string,
  'incentivized' ? : boolean,
  'isIndependent' ? : boolean,
  'isStaff' ? : boolean,
  'purchaseDateFormatted' ? : string,
  'recommend' ? : boolean,
  'dimensions' ? : Array < ReviewDimension > ,
    'profileAttributes' ? : ReviewProfileAttributes,
    'media' ? : Array < Media > ,
    'responsesBySource' ? : Array < {
      'source' ? : string,
      'responses' ? : Array < ReviewResponse >
    } > ,
    'syndication' ? : SyndicationAttribution,
    'updates' ? : Array < ReviewUpdate >
}
export interface ReviewDimension {
  'type' ? : number,
  'dimensionLabel' ? : string,
  'value' ? : number,
  'valueLabels' ? : Array < string >
}
export interface ReviewProfileAttributes {
  'ageRange' ? : string,
  'location' ? : string,
  'custom' ? : Array < {
    'label' ? : string,
    'value' ? : string
  } >
}
export interface ReviewResponse {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number,
  'isStaff' ? : boolean,
  'expertLabel' ? : string
}
export interface ReviewUpdate {
  'updateDateFormatted' ? : string,
  'text' ? : string,
  'rating' ? : number
}
export interface ReviewsListResponse {
  'productReviewsJsonLdEnabled' ? : boolean,
  'brand' ? : string,
  'catalogItemId' ? : number,
  'catalogItemTitle' ? : string,
  'filters' ? : Array < Filter > ,
    'parentCategoryIds' ? : Array < number > ,
    'total' ? : number,
    'reviews' ? : Array < Review >
}
export interface ReviewForm {
  'catItemId' ? : number,
  'deviceFingerprint' ? : string,
  'media' ? : Array < Media > ,
    'rating' ? : number,
    'source' ? : 0 | 1 | 2,
    'title' ? : string,
    'text' ? : string,
    'recommend' ? : boolean,
    'sweepstakesOptIn' ? : boolean,
    'dimensions' ? : Array < ReviewFormDimensions > ,
    'fromMobile' ? : boolean,
    'profile' ? : ReviewFormProfile
}
export interface ReviewFormDimensions {
  'id' ? : number,
  'value' ? : any
}
export interface ReviewFormProfile {
  'ageRange' ? : number,
  'ageRangeIsDirty' ? : boolean,
  'country' ? : string,
  'state' ? : string,
  'city' ? : string,
  'locationIsDirty' ? : boolean,
  'customAttributes' ? : Array < ReviewFormCustomAttributes >
}
export interface ReviewFormCustomAttributes {
  'id' ? : number,
  'value' ? : any
}
export interface ReviewInitData {
  'alreadyReviewed' ? : boolean,
  'purchasedItem' ? : boolean,
  'catItem' ? : CatalogItem,
  'dimensionDefinitions' ? : Array < ReviewInitDataDimension > ,
    'inboxSubmissionFormData' ? : ReviewInboxFormData,
    'shopperProfile' ? : ShopperProfile,
    'sellerRatingTransactionId' ? : number,
    'token' ? : string,
    'userData' ? : string,
    'userMedia' ? : Array < Media >
}
export interface ReviewInboxFormData {
  'rating' ? : number,
  'title' ? : string,
  'text' ? : string,
  'dimensions' ? : Array < ReviewFormDimensions >
}
export interface ReviewInitDataDimension {
  'id' ? : number,
  'type' ? : number,
  'label' ? : string,
  'required' ? : boolean,
  'displayAsTags' ? : boolean,
  'valueDefinitions' ? : Array < {
    'id' ? : string,
    'label' ? : string,
    'value' ? : number,
    'imageId' ? : string
  } >
}
export interface SellerRatingForm {
  'rating' ? : number,
  'source' ? : 0 | 1,
    'text' ? : string,
    'transactionId' ? : number
}
export interface SellerRatingInitData {
  'alreadyReviewed' ? : boolean,
  'hasTransaction' ? : boolean,
  'logoFileName' ? : string,
  'token' ? : string,
  'userData' ? : string
}
export interface ShopperProfile {
  'definitions' ? : ShopperProfileDefinitions,
  'values' ? : ShopperProfileValues
}
export interface ShopperProfileDefinitions {
  'ageRange' ? : {
    'required' ? : boolean,
    'ageRanges' ? : {
      [name: string]: string
    }
  },
  'location' ? : {
    'defaultCountry' ? : string,
    'required' ? : boolean,
    'countries' ? : {
      [name: string]: string
    },
    'caProvinces' ? : {
      [name: string]: string
    },
    'usStates' ? : {
      [name: string]: string
    }
  },
  'customAttributes' ? : Array < ProfileAttributeDefinition >
}
export interface ProfileAttributeDefinition {
  'id' ? : number,
  'type' ? : number,
  'label' ? : string,
  'required' ? : boolean,
  'displayAsTags' ? : boolean,
  'valueDefinitions' ? : Array < {
    'id' ? : string,
    'label' ? : string
  } >
}
export interface ShopperProfileValues {
  'ageRange' ? : string,
  'ageRangeIsDirty' ? : boolean,
  'country' ? : string,
  'state' ? : string,
  'city' ? : string,
  'customAttributes' ? : Array < ProfileAttributeValue >
}
export interface ProfileAttributeValue {
  'id' ? : number,
  'valueDefinitionId' ? : string,
  'freeFormText' ? : string
}
export interface SiteUser {
  'id' ? : number,
  'firstName' ? : string,
  'lastName' ? : string,
  'email' ? : string
}
export interface SpectrumResponse {
  'sku' ? : string,
  'positiveCount' ? : number,
  'criticalCount' ? : number,
  'positiveReview' ? : Review,
  'criticalReview' ? : Review
}
export interface SsoRequest {
  'submissionToken' ? : string,
  'action' ? : string,
  'userDataToken' ? : string
}
export interface SsoResponse {
  'ugcId' ? : number,
  'token' ? : string
}
export interface SyndicationAttribution {
  'sourceName' ? : string,
  'siteUrl' ? : string,
  'logoUrl' ? : string
}
export interface Ugc {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number
}
export interface UpdateCommentBody {
  'siteCatalogItemId' ? : number,
  'text': string
}
export interface UpdateUserIdentityBody {
  'isPrimary' ? : boolean
}
export interface UpdateUserIdentityResponse {
  'total' ? : number,
  'identities' ? : Array < UserIdentity >
}
export interface User {
  'id' ? : number,
  'nickName' ? : string,
  'firstName' ? : string,
  'lastName' ? : string
}
export interface UserIdentity {
  'id' ? : number,
  'email' ? : string,
  'isConfirmed' ? : boolean,
  'isPrimary' ? : boolean
}
export interface UserProfile {
  'id' ? : number,
  'nickName' ? : string,
  'firstName' ? : string,
  'lastName' ? : string,
  'country' ? : string,
  'city' ? : string,
  'state' ? : string,
  'ageRange' ? : number,
  'customAttributes' ? : Array < UserProfileAttributes >
}
export interface UserProfileAttributes {
  'id' ? : number,
  'label' ? : string,
  'required' ? : boolean,
  'type' ? : number,
  'collectDuringContentSubmit' ? : boolean,
  'values' ? : Array < {
    'id' ? : number,
    'label' ? : string,
    'value' ? : string,
    'sortOrder' ? : number,
    'hidden' ? : boolean
  } >
}
export interface UserUgcStats {
  'totalReviews' ? : number,
  'totalReviewLikes' ? : number,
  'totalPhotosVideos' ? : number,
  'totalPhotoVideoLikes' ? : number,
  'totalQuestions' ? : number,
  'totalQuestionLikes' ? : number,
  'totalAnswers' ? : number,
  'totalAnswerLikes' ? : number,
  'totalCheckoutComments' ? : number
}
export interface VcPinboardResponse {
  'total' ? : number,
  'media' ? : Array < VcPinboardItem >
}
export interface VcPinboardItem {
  'id' ? : number,
  'text' ? : string,
  'catItem' ? : CatalogItem,
  'user' ? : User,
  'dateCreatedFormatted' ? : string,
  'dateCreatedMillis' ? : number,
  'catItems' ? : Array < CatalogItem > ,
    'type' ? : 0 | 1,
    'width' ? : number,
    'height' ? : number,
    'imageId' ? : string,
    'imageProcessed' ? : boolean,
    'imageType' ? : string,
    'orientation' ? : number,
    'durationMillis' ? : number,
    'durationFormatted' ? : string,
    'thumbnailUrl' ? : string,
    'thumbnailWidth' ? : number,
    'thumbnailHeight' ? : number,
    'html' ? : string,
    'upVotes' ? : number,
    'averageRating' ? : number,
    'reviewCount' ? : number
}
export interface RegisterUserBody {
  'email': string,
  'firstName' ? : string,
  'lastName' ? : string,
  'nickName' ? : string,
  'sku' ? : string,
  'savedContentToken' ? : string,
  'stagedContentToken' ? : string
}
export interface FieldError {
  'code' ? : string,
  'path' ? : string
}
export interface RestError {
  'status' ? : number,
  'errorCode' ? : string,
  'fieldErrors' ? : Array < FieldError >
}
export interface ReviewsSummaryResponse {
  'catItem' ? : CatalogItem,
  'reviewsCount' ? : number,
  'recommendedPercentageFormatted' ? : string,
  'rating' ? : number,
  'ratingFormatted' ? : string,
  'ratingsBreakdown' ? : Array < {
      'rating' ? : number,
      'num' ? : number,
      'pctOfRatingsFormatted' ? : string
    } > ,
    'customDimensions' ? : Array < {
      'label' ? : string,
      'type' ? : number,
      'average' ? : number,
      'values' ? : Array < {
        'label' ? : string,
        'count' ? : number
      } >
    } >
}
export interface TopCommentsResponse {
  [sku: string]: Array < Comment >
}
export interface TransactionItemsForCommentResponse {
  'token' ? : string,
  'siteUser' ? : SiteUser,
  'items' ? : Array < TransactionItemForComment >
}
export interface TransactionItemForComment {
  'transactionItemId' ? : number,
  'siteKey' ? : string,
  'existingCommentText' ? : string,
  'latestDateFormatted' ? : string,
  'catItem' ? : CatalogItem
}
export interface GalleryBreakpoint {
  'viewport' ? : number,
  'size' ? : number,
  'showCaptions' ? : boolean
}
export interface ChatterBreakpoint {
  'viewport' ? : number,
  'numOfCols' ? : number,
  'hSpacing' ? : number,
  'vSpacing' ? : number
}
export interface ChatterConfig {
  'breakpointsConfig' ? : Array < ChatterBreakpoint > ,
    'limit' ? : number,
    'minCount' ? : number,
    'minCharacterCount' ? : number,
    'minWordCount' ? : number,
    'truncateLength' ? : number,
    'truncateAllowance' ? : number,
    'includeSyndicated' ? : boolean,
    'sortOrder' ? : number,
    'widgetDivId' ? : string
}
export interface CommentCaptureConfig {
  'delayDisplaySeconds' ? : number,
  'enabled' ? : boolean,
  'showUsername' ? : boolean,
  'embed' ? : boolean,
  'paginate' ? : boolean,
  'widgetDivId' ? : string
}
export interface CommentsPinboardBreakpoint {
  'viewport' ? : number,
  'minWidth' ? : number,
  'maxWidth' ? : number,
  'hSpacing' ? : number,
  'vSpacing' ? : number
}
export interface CommentsPinboardConfig {
  'activeOnly' ? : boolean,
  'breakpointsConfig' ? : Array < CommentsPinboardBreakpoint > ,
    'commentMaxLength' ? : number,
    'hoverTitleMaxLength' ? : number,
    'includeSyndicated' ? : boolean,
    'limit' ? : number,
    'maxCommentsReturned' ? : number,
    'maxDaysOld' ? : number,
    'progressiveLoading' ? : boolean,
    'showReviewStars' ? : boolean,
    'titleMaxLength' ? : number,
    'userNameMaxLength' ? : number,
    'widgetDivId' ? : string
}
export interface CommentsPinboardTeaserBreakpoint {
  'viewport' ? : number,
  'minWidth' ? : number,
  'commentLinesLimit' ? : number,
  'promoPlacement' ? : string,
  'spacing' ? : number
}
export interface CommentsPinboardTeaserConfig {
  'activeOnly' ? : boolean,
  'breakpointsConfig' ? : Array < CommentsPinboardTeaserBreakpoint > ,
    'commentMaxLength' ? : number,
    'hoverTitleMaxLength' ? : number,
    'includeSyndicated' ? : boolean,
    'maxDaysOld' ? : number,
    'promoButtonUrl' ? : string,
    'showReviewStars' ? : boolean,
    'titleMaxLength' ? : number,
    'userNameMaxLength' ? : number,
    'widgetDivId' ? : string
}
export interface FilterOption {
  'value' ? : any,
  'label' ? : string,
  'labelKey' ? : string
}
export interface Filter {
  'name' ? : string,
  'group' ? : string,
  'isRating' ? : boolean,
  'label' ? : string,
  'labelKey' ? : string,
  'type' ? : "boolean" | "string" | "number" | "array",
  'options' ? : Array < FilterOption >
}
export interface GalleryConfig {
  'arrowLocation' ? : "top" | "overlay" | "bottom",
  'arrowStyle' ? : "button" | "icon",
  'breakpoints' ? : Array < GalleryBreakpoint > ,
    'columnSpacing' ? : number,
    'includeProductSiblings' ? : boolean,
    'includeSyndicated' ? : boolean,
    'minContentCount' ? : number,
    'maxContentToReturn' ? : number,
    'minTextContentCharacterCount' ? : number,
    'minTextContentWordCount' ? : number,
    'showProgressBar' ? : boolean,
    'truncateLength' ? : number,
    'sortOrder' ? : "MOST_VOTES" | "MOST_RECENT" | "LONGEST",
    'widgetDivId' ? : string
}
export interface GlobalConfig {
  'additionalPagingScroll' ? : number,
  'authSettings' ? : AuthSettings,
  'mediaEnabled' ? : boolean,
  'multiItemAnswerEnabled' ? : boolean,
  'multiItemPickerTitleLength' ? : number,
  'siteName' ? : string,
  'ssoEnabled' ? : boolean
}
export interface AuthSettings {
  'question' ? : 1 | 2 | 3,
    'answerReply' ? : 1 | 2,
    'review' ? : 1 | 3 | 4
}
export interface InstantAnswersConfig {
  'initialPageSize' ? : number,
  'pageSize' ? : number,
  'learnMoreEnabled' ? : boolean,
  'multiItemQuestionEnabled' ? : boolean,
  'widgetDivId' ? : string
}
export interface Layout {
  'headerItems' ? : Array < string > ,
    'columns' ? : Array < LayoutColumn > ,
    'footerItems' ? : Array < string >
}
export interface LayoutColumn {
  'width' ? : number,
  'rightMargin' ? : number,
  'items' ? : Array < string >
}
export interface LayoutConfig {
  'breakpoint' ? : number,
  'layout' ? : Layout
}
export interface QaCommentsConfig {
  'initialPageSize' ? : number,
  'includeSyndicated' ? : boolean,
  'limit' ? : number,
  'minCount' ? : number,
  'minCharacterCount' ? : number,
  'minWordCount' ? : number,
  'sortOrder' ? : 0 | 1,
    'truncateAllowance' ? : number,
    'truncateLength' ? : number
}
export interface QaConfig {
  'comments' ? : QaCommentsConfig,
  'defaultSortOption' ? : "RECENT" | "OLDEST" | "BEST" | "MOST_ANSWERS" | "LEAST_ANSWERS" | "MOST_RECENT_ANSWER" | "OLDEST_ANSWER",
  'defaultSortOptionName' ? : "RECENT" | "OLDEST" | "BEST" | "MOST_ANSWERS" | "LEAST_ANSWERS" | "MOST_RECENT_ANSWER" | "OLDEST_ANSWER",
  'displayUserToolbar' ? : boolean,
  'hideBestAnswer' ? : boolean,
  'initialPageSize' ? : number,
  'pageSize' ? : number,
  'relatedInitialPageSize' ? : number,
  'relatedPageSize' ? : number,
  'showCheckoutChatterOnQAWidget' ? : boolean,
  'sortOptions' ? : Array < string > ,
    'widgetDivId' ? : string,
    'relatedQuestionsDisplay' ? : "NONE" | "INCLUDED" | "SEPARATE"
}
export interface ReviewBreakpointConfig {
  'breakpoint' ? : number,
  'layout' ? : Layout,
  'mediaSize' ? : number,
  'truncateLength' ? : number
}
export interface ReviewsListConfig {
  'breakpoints' ? : Array < ReviewBreakpointConfig > ,
    'defaultSortOption' ? : string,
    'displayUserToolbar' ? : boolean,
    'hideWriteReview' ? : boolean,
    'initialPageSize' ? : number,
    'pageSize' ? : number,
    'relatedInitialPageSize' ? : number,
    'relatedPageSize' ? : number,
    'relatedReviewsDisplay' ? : "NONE" | "INCLUDED" | "SEPARATE",
    'showPurchaserBadge' ? : boolean,
    'sortOptions' ? : Array < string > ,
    'toggleFiltersDesktop' ? : boolean,
    'toggleFiltersMobile' ? : boolean,
    'useShowMore' ? : boolean,
    'widgetDivId' ? : string
}
export interface ReviewsSummaryConfig {
  'aggregateMetaOn' ? : boolean,
  'aggregateJsonLdMetaOn' ? : boolean,
  'breakpoints' ? : Array < LayoutConfig > ,
    'childWidgets' ? : {
      [name: string]: any
    },
    'layouts' ? : Array < LayoutConfig > ,
    'widgetDivId' ? : string
}
export interface ReviewSubmissionConfig {
  'deviceFingerprintOn' ? : boolean,
  'mediaSizes' ? : Array < MediaSize > ,
    'recommendRequired' ? : boolean,
    'textMinLength' ? : number,
    'textMaxLength' ? : number,
    'textRequired' ? : boolean,
    'showRecommend' ? : boolean,
    'showSweepstakes' ? : boolean,
    'titleMaxLength' ? : number,
    'titleRequired' ? : boolean
}
export interface SellerRatingSubmissionConfig {
  'textMinLength' ? : number,
  'textMaxLength' ? : number
}
export interface SortOption {
  'name' ? : string,
  'title' ? : string
}
export interface SpectrumConfig {
  'widgetDivId' ? : string
}
export interface TopCommentsConfig {
  'includeSyndicated' ? : boolean,
  'minCharacterCount' ? : number,
  'minWordCount' ? : number,
  'truncateLength' ? : number,
  'truncateAllowance' ? : number
}
export interface VcPinboardConfig {
  'activeOnly' ? : boolean,
  'breakpointsConfig' ? : Array < VcPinboardBreakpoint > ,
    'hoverTitleMaxLength' ? : number,
    'limit' ? : number,
    'minCaptionCharCount' ? : number,
    'minCaptionWordCount' ? : number,
    'maxCaptionLength' ? : number,
    'progressiveLoading' ? : boolean,
    'showCaption' ? : boolean,
    'showDatestamp' ? : boolean,
    'showReviewStars' ? : boolean,
    'sortOrder' ? : "MOST_VOTES" | "MOST_RECENT" | "LONGEST",
    'userNameMaxLength' ? : number,
    'widgetDivId' ? : string
}
export interface VcPinboardBreakpoint {
  'viewport' ? : number,
  'minWidth' ? : number,
  'maxWidth' ? : number,
  'hSpacing' ? : number,
  'vSpacing' ? : number
}
export interface UgcCounts {
  'questions' ? : number,
  'directQuestions' ? : number,
  'answers' ? : number,
  'directAnswers' ? : number,
  'reviews' ? : number,
  'avgRating' ? : number,
  'relatedReviews' ? : number,
  'comments' ? : number,
  'active' ? : boolean
}

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'

function createRestError(xhr: TTXMLHttpRequest): RestError {
  /* beautify ignore:start */
  const restError = {
    status: xhr.status,
    fieldErrors: []
  } as RestError
  /* beautify ignore:end */
  const errorsStr = xhr.getResponseHeader('turnto-error-msg')
  if (xhr.getResponseHeader('turnto-error') && errorsStr) {
    try {
      JSON.parse(errorsStr).forEach((error) => {
        if (error.path) {
          restError.fieldErrors.push(error)
        } else {
          restError.errorCode = error.code
        }
      })
    } catch (e) {
      restError.errorCode = 'unexpected-error'
    }
  } else {
    restError.errorCode = 'unexpected-error'
  }
  return restError
}

function createOfflineRestError(xhr: TTXMLHttpRequest): RestError {
  /* beautify ignore:start */
  return {
    status: xhr.status,
    fieldErrors: [],
    errorCode: "turnto-offline"
  } as RestError
  /* beautify ignore:end */
}

function populatePathValues(path: string, params: any = {}) {
  const fieldsInPathRegEx = /{(.*?)}/g
  // globally replacing siteKey and locale without needing to pass in calls
  const replaceMap = {
    '{siteKey}': hostsConfig.siteKey,
    '{locale}': turnToConfig.locale
  }
  // this loop finds each path variable and adds to the replaceMap.
  // a path variable is surrounded by curly braces.
  // Example with siteKey and id: /{siteKey}/review/{id}
  let match
  while (match = fieldsInPathRegEx.exec(path)) {
    const fieldName = match[1]
    if (fieldName !== 'siteKey' && fieldName !== 'locale') {
      replaceMap[`{${fieldName}}`] = params[fieldName]
    }
  }
  // this regex and replace, replaces each path variable with its value
  const replaceRegEx = new RegExp(Object.keys(replaceMap).join("|"), "gi")
  return path.replace(replaceRegEx, (matched => replaceMap[matched]))
}

function call < T = any > (
  method: HttpMethod,
  path: string,
  parameters: any = {},
  requiredFields: string[],
  queryFields: string[],
  headerFields: string[],
  body: any = {}
): Promise < T > {
  let queryParameters: any = {}
  let headers: any = {}

  requiredFields.forEach((fieldName) => {
    if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
      throw new Error(`Missing required  parameter: ${fieldName}`)
    }
  })
  queryFields.forEach((fieldName) => {
    if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
      queryParameters[fieldName] = parameters[fieldName]
    }
  })
  headerFields.forEach((fieldName) => {
    if (parameters[fieldName] !== undefined && parameters[fieldName] !== null) {
      headers[fieldName] = parameters[fieldName]
    }
  })
  const populatedPath = populatePathValues(path, parameters)

  return new Promise < T > ((resolve, reject) => {
    executeRequest(method, populatedPath, {
      body,
      headers,
      params: queryParameters
    }).then((xhr) => {
      const offline = xhr.getResponseHeader('turnto-offline')
      if (offline === 'true') {
        reject(createOfflineRestError(xhr))
      } else if (xhr.status === 200 || xhr.status === 201) {
        resolve(xhr.data)
      } else {
        reject((createRestError(xhr)))
      }
    }).catch((xhr) => {
      reject(createRestError(xhr))
    })
  })
}

function callStatic < T = any > (
  path: string,
  parameters: any = {},
  requiredFields: string[]
): Promise < T > {
  requiredFields.forEach((fieldName) => {
    if (parameters[fieldName] === undefined || parameters[fieldName] === null) {
      throw new Error(`Missing required  parameter: ${fieldName}`)
    }
  })
  const populatedPath = populatePathValues(path, parameters)

  return new Promise < T > ((resolve, reject) => {
    executeStaticRequest(populatedPath).then((xhr) => {
      const offline = xhr.getResponseHeader('turnto-offline')
      if (offline === 'true') {
        reject(createOfflineRestError(xhr))
      } else if (xhr.status === 200) {
        resolve(xhr.data)
      } else {
        reject((createRestError(xhr)))
      }
    }).catch((xhr) => {
      reject(createRestError(xhr))
    })
  })
}

/**
 * v5 Widget API
 * @class ApiService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class ApiService {
  uploadFile < T = any > (
    path: string,
    formData: FormData,
    progressCallback
  ): Promise < T > {
    return new Promise < T > ((resolve, reject) => {
      executeRequest < T > (
        'POST',
        path,
        // progressCallback function updates the progress as it's being uploaded
        {
          formData,
          progressCallback
        }
      ).then((xhr) => {
        if (xhr.status === 200 || xhr.status === 201) {
          resolve(xhr.data)
        } else {
          reject((createRestError(xhr)))
        }
      }).catch((xhr) => {
        reject(createRestError(xhr))
      })
    })
  }

  /**
   * Get article by id
   *
   * @method
   * @name ApiService#getArticleById
   * @param {integer} id - 
   */
  getArticleById(
    parameters: {
      id: number
    }
  ): Promise < Article > {

    return call < Article > (
      'GET',
      '/{siteKey}/article/{id}/{locale}',
      parameters,
      ['id'],
      [],
      []

    )
  }

  /**
   * Retrieve catalog items
   *
   * @method
   * @name ApiService#getCatalogItems
   * @param {object} body -    
   * {
   *   searchTerm:string
   *   excludeCatItemIds:array
   *   currentSku:string
   * }
   */
  getCatalogItems(
    body: {
      searchTerm ? : string,
      excludeCatItemIds ? : Array < number > ,
      currentSku ? : string
    }
  ): Promise < GetCatalogItemsResponse > {

    return call < GetCatalogItemsResponse > (
      'POST',
      '/{siteKey}/catalogItem/search', {},
      [],
      [],
      [], body
    )
  }

  /**
   * Retrieve catalog items containing comments for the comments pinboard
   *
   * @method
   * @name ApiService#getCatalogItemsForCommentsPinboard
   * @param {string} skus - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {boolean} activeOnly - 
   * @param {string} brands - 
   * @param {string} tags - 
   * @param {boolean} includeCommentsCount - 
   * @param {boolean} includeReviewData - 
   * @param {integer} maxDaysOld - Specify -1 to include all, regardless of age
   * @param {boolean} includeSyndicated - 
   * @param {integer} minComments - 
   * @param {integer} maxCommentsReturned - 
   */
  getCatalogItemsForCommentsPinboard(
    parameters: {
      skus: string,
      offset: number,
      limit: number,
      activeOnly: boolean,
      brands: string,
      tags: string,
      includeCommentsCount: boolean,
      includeReviewData: boolean,
      maxDaysOld: number,
      includeSyndicated: boolean,
      minComments: number,
      maxCommentsReturned: number
    }
  ): Promise < GetCatalogItemsForCommentsPinboardResponse > {

    return callStatic < GetCatalogItemsForCommentsPinboardResponse > (
      '/sitedata/{siteKey}/commentsPinboard/{skus}/{locale}/{offset}/{limit}/{activeOnly}/{brands}/{tags}/{includeCommentsCount}/{includeReviewData}/{maxDaysOld}/{includeSyndicated}/{minComments}/{maxCommentsReturned}',
      parameters,
      ['skus', 'offset', 'limit', 'activeOnly', 'brands', 'tags', 'includeCommentsCount', 'includeReviewData', 'maxDaysOld', 'includeSyndicated', 'minComments', 'maxCommentsReturned']
    )
  }

  /**
   * Save a new comment
   *
   * @method
   * @name ApiService#createComment
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {CreateCommentBody} body - 
   */
  createComment(
    parameters: {
      'context-token': string,
      sku: string,
      checkoutSiteKey ? : string,
    },
    body: CreateCommentBody
  ): Promise < {
    'id' ? : number
  } > {

    return call < {
      'id' ? : number
    } > (
      'POST',
      '/{siteKey}/comment',
      parameters,
      ['context-token', 'sku', ],
      ['sku', 'checkoutSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Comments for chatter
   *
   * @method
   * @name ApiService#chatterComments
   * @param {string} sku - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {string} sort - Possible values are:
   * 0 (default) - by id, descending
   * 1 - by length of comment text, descending
  
   * @param {integer} minCharCount - 
   * @param {integer} minWordCount - 
   * @param {boolean} includeSyndicated - 
   */
  chatterComments(
    parameters: {
      sku: string,
      offset: number,
      limit: number,
      sort: 0 | 1,
      minCharCount: number,
      minWordCount: number,
      includeSyndicated: boolean
    }
  ): Promise < ChatterCommentsResponse > {

    return callStatic < ChatterCommentsResponse > (
      '/sitedata/{siteKey}/chatter/{sku}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}',
      parameters,
      ['sku', 'offset', 'limit', 'sort', 'minCharCount', 'minWordCount', 'includeSyndicated']
    )
  }

  /**
   * This is only intended to be done right after comment creation
   *
   * @method
   * @name ApiService#updateComment
   * @param {string} contextToken - 
   * @param {integer} id - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {UpdateCommentBody} body - 
   */
  updateComment(
    parameters: {
      'context-token': string,
      id: number,
      sku: string,
      checkoutSiteKey ? : string,
    },
    body: UpdateCommentBody
  ): Promise < void > {

    return call < void > (
      'PUT',
      '/{siteKey}/comment/{id}',
      parameters,
      ['context-token', 'id', 'sku', ],
      ['sku', 'checkoutSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * This is only intended to be done right after comment creation
   *
   * @method
   * @name ApiService#deleteComment
   * @param {string} contextToken - 
   * @param {integer} id - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   */
  deleteComment(
    parameters: {
      'context-token': string,
      id: number,
      sku: string,
      checkoutSiteKey ? : string
    }
  ): Promise < void > {

    return call < void > (
      'DELETE',
      '/{siteKey}/comment/{id}',
      parameters,
      ['context-token', 'id', 'sku', ],
      ['sku', 'checkoutSiteKey'],
      ['context-token', ]

    )
  }

  /**
   * Top comments
   *
   * @method
   * @name ApiService#topComments
   * @param {string} skus - Comma separated list of skus
   * @param {integer} minCharCount - 
   * @param {integer} minWordCount - 
   * @param {string} tags - Comma separated list of tags
   * @param {boolean} includeSyndicated - 
   */
  topComments(
    parameters: {
      skus: string,
      minCharCount: number,
      minWordCount: number,
      tags: string,
      includeSyndicated: boolean
    }
  ): Promise < TopCommentsResponse > {

    return callStatic < TopCommentsResponse > (
      '/sitedata/{siteKey}/topcomment/{skus}/{locale}/{minCharCount}/{minWordCount}/{tags}/{includeSyndicated}',
      parameters,
      ['skus', 'minCharCount', 'minWordCount', 'tags', 'includeSyndicated']
    )
  }

  /**
   * List of media
   *
   * @method
   * @name ApiService#mediaList
   * @param {string} skus - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {string} sort - Possible values are: MOST_VOTES, MOST_RECENT, and LONGEST
   * @param {boolean} includeProductSiblings - 
   * @param {string} tags - 
   * @param {integer} minCharCount - 
   * @param {integer} minWordCount - 
   * @param {boolean} includeSyndicated - 
   */
  mediaList(
    parameters: {
      skus: string,
      offset: number,
      limit: number,
      sort: "MOST_VOTES" | "MOST_RECENT" | "LONGEST",
      includeProductSiblings: boolean,
      tags: string,
      minCharCount: number,
      minWordCount: number,
      includeSyndicated: boolean
    }
  ): Promise < MediaListResponse > {

    return callStatic < MediaListResponse > (
      '/sitedata/{siteKey}/gallery/{skus}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}/{includeProductSiblings}/{tags}',
      parameters,
      ['skus', 'offset', 'limit', 'sort', 'includeProductSiblings', 'tags', 'minCharCount', 'minWordCount', 'includeSyndicated']
    )
  }

  /**
   * Vote for a media item
   *
   * @method
   * @name ApiService#voteForMedia
   * @param {integer} id - 
   */
  voteForMedia(
    parameters: {
      id: number
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/media/{id}/vote',
      parameters,
      ['id'],
      [],
      []

    )
  }

  /**
   * Flag a media item as inappropriate
   *
   * @method
   * @name ApiService#flagMedia
   * @param {integer} id - 
   * @param {string} reason - Possible values:
  *   ipViolation
  *   offensive
  *   offTopic
  *   spam
  
   */
  flagMedia(
    parameters: {
      id: number,
      reason: "ipViolation" | "offensive" | "offTopic" | "spam"
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/media/{id}/flag',
      parameters,
      ['id', 'reason'],
      ['reason'],
      []

    )
  }

  /**
   * Save a batch of media items
   *
   * @method
   * @name ApiService#saveMedia
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {CreateMediaItemsBody} body - 
   */
  saveMedia(
    parameters: {
      'context-token': string,
      sku: string,
      checkoutSiteKey ? : string,
    },
    body: CreateMediaItemsBody
  ): Promise < Array < Media >> {

    return call < Array < Media >> (
      'POST',
      '/{siteKey}/media/batch',
      parameters,
      ['context-token', 'sku', ],
      ['sku', 'checkoutSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Initialization data for the share media flow (coming from rse)
   *
   * @method
   * @name ApiService#shareMediaInitData
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {string} ssoProfileToken - 
   */
  shareMediaInitData(
    parameters: {
      'context-token' ? : string,
      sku: string,
      checkoutSiteKey ? : string,
      ssoProfileToken ? : string
    }
  ): Promise < MediaInitData > {

    return call < MediaInitData > (
      'GET',
      '/{siteKey}/media/initData',
      parameters,
      ['sku', ],
      ['sku', 'checkoutSiteKey', 'ssoProfileToken'],
      ['context-token', ]

    )
  }

  /**
   * TODO - need to make this work or remove.  Currently using hard-coded call set in api-service called uploadFile
   *
   * @method
   * @name ApiService#uploadMedia
   * @param {file} file - 
   * @param {string} uploadId - 
   */
  uploadMedia(
    parameters: {
      file: void,
      uploadId: string
    }
  ): Promise < MediaUploadResponse > {

    return call < MediaUploadResponse > (
      'POST',
      '/{siteKey}/media/upload',
      parameters,
      ['file', 'uploadId'],
      [],
      []

    )
  }

  /**
   * Post a video link for validation and return details
   *
   * @method
   * @name ApiService#addVideoLink
   * @param {string} url - 
   */
  addVideoLink(
    parameters: {
      url: string
    }
  ): Promise < AddVideoLinkResponse > {

    return call < AddVideoLinkResponse > (
      'POST',
      '/{siteKey}/media/videoLink',
      parameters,
      ['url'],
      ['url'],
      []

    )
  }

  /**
   * Retrieve media for vc pinboard
   *
   * @method
   * @name ApiService#getMediaForVcPinboard
   * @param {string} skus - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {boolean} activeOnly - 
   * @param {string} brands - 
   * @param {string} tags - 
   * @param {integer} sortOrder - Possible values are: MOST_VOTES, MOST_RECENT, and LONGEST
   * @param {boolean} includeReviewData - 
   * @param {integer} minCaptionCharCount - 
   * @param {integer} minCaptionWordCount - 
   */
  getMediaForVcPinboard(
    parameters: {
      skus: string,
      offset: number,
      limit: number,
      activeOnly: boolean,
      brands: string,
      tags: string,
      sortOrder: "MOST_VOTES" | "MOST_RECENT" | "LONGEST",
      includeReviewData: boolean,
      minCaptionCharCount: number,
      minCaptionWordCount: number
    }
  ): Promise < VcPinboardResponse > {

    return callStatic < VcPinboardResponse > (
      '/sitedata/{siteKey}/vcPinboard/{skus}/{locale}/{offset}/{limit}/{activeOnly}/{brands}/{tags}/{sortOrder}/{includeReviewData}/{minCaptionCharCount}/{minCaptionWordCount}',
      parameters,
      ['skus', 'offset', 'limit', 'activeOnly', 'brands', 'tags', 'sortOrder', 'includeReviewData', 'minCaptionCharCount', 'minCaptionWordCount']
    )
  }

  /**
   * List of questions
   *
   * @method
   * @name ApiService#questionsList
   * @param {string} sku - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {string} sort - Default value depends on site settings:
   * RECENT
   * OLDEST
   * BEST
   * MOST_ANSWERS
   * LEAST_ANSWERS
   * MOST_RECENT_ANSWER
   * OLDEST_ANSWER
  
   * @param {boolean} includeRelated - 
   */
  questionsList(
    parameters: {
      sku: string,
      offset: number,
      limit: number,
      sort: "RECENT" | "OLDEST" | "BEST" | "MOST_ANSWERS" | "LEAST_ANSWERS" | "MOST_RECENT_ANSWER" | "OLDEST_ANSWER",
      includeRelated ? : boolean
    }
  ): Promise < QuestionsListResponse > {

    return callStatic < QuestionsListResponse > (
      '/sitedata/{siteKey}/{sku}/d/question/{locale}/{offset}/{limit}/{sort}/{includeRelated}',
      parameters,
      ['sku', 'offset', 'limit', 'sort', ]
    )
  }

  /**
   * List of related questions
   *
   * @method
   * @name ApiService#relatedQuestionsList
   * @param {string} sku - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {string} sort - Default value depends on site settings:
   * RECENT
   * OLDEST
   * BEST
   * MOST_ANSWERS
   * LEAST_ANSWERS
   * MOST_RECENT_ANSWER
   * OLDEST_ANSWER
  
   */
  relatedQuestionsList(
    parameters: {
      sku: string,
      offset: number,
      limit: number,
      sort: "RECENT" | "OLDEST" | "BEST" | "MOST_ANSWERS" | "LEAST_ANSWERS" | "MOST_RECENT_ANSWER" | "OLDEST_ANSWER"
    }
  ): Promise < RelatedQuestionsListResponse > {

    return callStatic < RelatedQuestionsListResponse > (
      '/sitedata/{siteKey}/{sku}/r/relatedquestion/{locale}/{offset}/{limit}/{sort}',
      parameters,
      ['sku', 'offset', 'limit', 'sort']
    )
  }

  /**
   * Create a question (anonymous or unconfirmed user)
   *
   * @method
   * @name ApiService#createQuestionAnonOrUnconfirmedUser
   * @param {string} qualifier - 
   * @param {string} sku - 
   * @param {CreateQuestionBody} body - 
   */
  createQuestionAnonOrUnconfirmedUser(
    parameters: {
      qualifier: string,
      sku: string,
    },
    body: CreateQuestionBody
  ): Promise < {
    'questionId' ? : number,
    'savedQuestionToken' ? : string,
    'stagedQuestionToken' ? : string
  } > {

    return call < {
      'questionId' ? : number,
      'savedQuestionToken' ? : string,
      'stagedQuestionToken' ? : string
    } > (
      'POST',
      '/{siteKey}/question/inline/{qualifier}',
      parameters,
      ['qualifier', 'sku', ],
      ['sku', ],
      [], body
    )
  }

  /**
   * Create a question (confirmed user)
   *
   * @method
   * @name ApiService#createQuestionConfirmedUser
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {CreateQuestionBody} body - 
   */
  createQuestionConfirmedUser(
    parameters: {
      'context-token': string,
      sku: string,
    },
    body: CreateQuestionBody
  ): Promise < {
    'questionId' ? : number
  } > {

    return call < {
      'questionId' ? : number
    } > (
      'POST',
      '/{siteKey}/question/inline/confirmed',
      parameters,
      ['context-token', 'sku', ],
      ['sku', ],
      ['context-token', ], body
    )
  }

  /**
   * Create an answer
   *
   * @method
   * @name ApiService#createAnswer
   * @param {string} contextToken - 
   * @param {string} qualifier - confirmed or unconfirmed
   * @param {string} sku - 
   * @param {string} originSiteKey - 
   * @param {CreateAnswerBody} body - 
   */
  createAnswer(
    parameters: {
      'context-token' ? : string,
      qualifier ? : string,
      sku: string,
      originSiteKey ? : string,
    },
    body: CreateAnswerBody
  ): Promise < {
    'answerId' ? : number,
    'stagedAnswerToken' ? : string
  } > {

    return call < {
      'answerId' ? : number,
      'stagedAnswerToken' ? : string
    } > (
      'POST',
      '/{siteKey}/answer/inline/{qualifier}',
      parameters,
      ['sku', ],
      ['sku', 'originSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Create an answer from an email
   *
   * @method
   * @name ApiService#createEmailAnswer
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} originSiteKey - 
   * @param {CreateAnswerBody} body - 
   */
  createEmailAnswer(
    parameters: {
      'context-token' ? : string,
      sku: string,
      originSiteKey ? : string,
    },
    body: CreateAnswerBody
  ): Promise < {
    'answerId' ? : number
  } > {

    return call < {
      'answerId' ? : number
    } > (
      'POST',
      '/{siteKey}/answer/email',
      parameters,
      ['sku', ],
      ['sku', 'originSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Initialization data for coming from question email to answer the question
   *
   * @method
   * @name ApiService#answerInitData
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} ssoProfileToken - 
   */
  answerInitData(
    parameters: {
      'context-token': string,
      sku: string,
      ssoProfileToken ? : string
    }
  ): Promise < AnswerInitData > {

    return call < AnswerInitData > (
      'GET',
      '/{siteKey}/answer/initData',
      parameters,
      ['context-token', 'sku', ],
      ['sku', 'ssoProfileToken'],
      ['context-token', ]

    )
  }

  /**
   * Vote for a question
   *
   * @method
   * @name ApiService#voteQuestion
   * @param {string} sku - 
   * @param {string} originSiteKey - 
   * @param {integer} id - 
   * @param {object} body -    
   * {
   *   up:number
   * }
   */
  voteQuestion(
    parameters: {
      sku: string,
      originSiteKey ? : string,
      id: number,
    },
    body: {
      up ? : number
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/question/{id}/vote',
      parameters,
      ['sku', 'id', ],
      ['sku', 'originSiteKey', ],
      [], body
    )
  }

  /**
   * Get question data by id
   *
   * @method
   * @name ApiService#getQuestionData
   * @param {string} originSiteKey - 
   * @param {integer} id - 
   */
  getQuestionData(
    parameters: {
      originSiteKey ? : string,
      id: number
    }
  ): Promise < Question > {

    return call < Question > (
      'GET',
      '/{siteKey}/question/{id}/{locale}',
      parameters,
      ['id'],
      ['originSiteKey', ],
      []

    )
  }

  /**
   * Flag an answer as inappropriate
   *
   * @method
   * @name ApiService#flagAnswer
   * @param {string} sku - 
   * @param {string} originSiteKey - 
   * @param {integer} id - 
   */
  flagAnswer(
    parameters: {
      sku: string,
      originSiteKey ? : string,
      id: number
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/answer/{id}/flag',
      parameters,
      ['sku', 'id'],
      ['sku', 'originSiteKey', ],
      []

    )
  }

  /**
   * Vote for an answer
   *
   * @method
   * @name ApiService#voteAnswer
   * @param {string} sku - 
   * @param {string} originSiteKey - 
   * @param {integer} id - 
   * @param {object} body -    
   * {
   *   up:number
   * }
   */
  voteAnswer(
    parameters: {
      sku: string,
      originSiteKey ? : string,
      id: number,
    },
    body: {
      up ? : number
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/answer/{id}/vote',
      parameters,
      ['sku', 'id', ],
      ['sku', 'originSiteKey', ],
      [], body
    )
  }

  /**
   * Create a reply to an answer
   *
   * @method
   * @name ApiService#createReply
   * @param {string} contextToken - 
   * @param {string} qualifier - confirmed or unconfirmed
   * @param {string} sku - 
   * @param {string} originSiteKey - 
   * @param {CreateReplyBody} body - 
   */
  createReply(
    parameters: {
      'context-token' ? : string,
      qualifier: string,
      sku: string,
      originSiteKey ? : string,
    },
    body: CreateReplyBody
  ): Promise < {
    'stagedReplyToken' ? : string
  } > {

    return call < {
      'stagedReplyToken' ? : string
    } > (
      'POST',
      '/{siteKey}/reply/inline/{qualifier}',
      parameters,
      ['qualifier', 'sku', ],
      ['sku', 'originSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Create a reply from an email
   *
   * @method
   * @name ApiService#createEmailReply
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} originSiteKey - 
   * @param {CreateReplyBody} body - 
   */
  createEmailReply(
    parameters: {
      'context-token' ? : string,
      sku: string,
      originSiteKey ? : string,
    },
    body: CreateReplyBody
  ): Promise < {
    'stagedReplyToken' ? : string
  } > {

    return call < {
      'stagedReplyToken' ? : string
    } > (
      'POST',
      '/{siteKey}/reply/email',
      parameters,
      ['sku', ],
      ['sku', 'originSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Initialization data for coming from answer or reply email to reply
   *
   * @method
   * @name ApiService#replyInitData
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} ssoProfileToken - 
   */
  replyInitData(
    parameters: {
      'context-token': string,
      sku: string,
      ssoProfileToken ? : string
    }
  ): Promise < ReplyInitData > {

    return call < ReplyInitData > (
      'GET',
      '/{siteKey}/reply/initData',
      parameters,
      ['context-token', 'sku', ],
      ['sku', 'ssoProfileToken'],
      ['context-token', ]

    )
  }

  /**
   * Save a new review by an unconfirmed user
   *
   * @method
   * @name ApiService#saveReviewUnconfirmed
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {ReviewForm} body - 
   */
  saveReviewUnconfirmed(
    parameters: {
      sku: string,
      checkoutSiteKey ? : string,
    },
    body: ReviewForm
  ): Promise < {
    'stagedReviewToken' ? : string
  } > {

    return call < {
      'stagedReviewToken' ? : string
    } > (
      'POST',
      '/{siteKey}/review/inline/unconfirmed',
      parameters,
      ['sku', ],
      ['sku', 'checkoutSiteKey', ],
      [], body
    )
  }

  /**
   * Save a new review by a confirmed (logged-in) user
   *
   * @method
   * @name ApiService#saveReviewConfirmed
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {ReviewForm} body - 
   */
  saveReviewConfirmed(
    parameters: {
      'context-token': string,
      sku: string,
      checkoutSiteKey ? : string,
    },
    body: ReviewForm
  ): Promise < {
    'reviewId' ? : number
  } > {

    return call < {
      'reviewId' ? : number
    } > (
      'POST',
      '/{siteKey}/review/inline/confirmed',
      parameters,
      ['context-token', 'sku', ],
      ['sku', 'checkoutSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Save a new review from an RSE
   *
   * @method
   * @name ApiService#saveReviewRse
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {ReviewForm} body - 
   */
  saveReviewRse(
    parameters: {
      'context-token': string,
      sku: string,
      checkoutSiteKey ? : string,
    },
    body: ReviewForm
  ): Promise < {
    'reviewId' ? : number
  } > {

    return call < {
      'reviewId' ? : number
    } > (
      'POST',
      '/{siteKey}/review/email',
      parameters,
      ['context-token', 'sku', ],
      ['sku', 'checkoutSiteKey', ],
      ['context-token', ], body
    )
  }

  /**
   * Initialization data for the review form
   *
   * @method
   * @name ApiService#reviewInitData
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {string} ssoProfileToken - 
   */
  reviewInitData(
    parameters: {
      'context-token' ? : string,
      sku: string,
      checkoutSiteKey ? : string,
      ssoProfileToken ? : string
    }
  ): Promise < ReviewInitData > {

    return call < ReviewInitData > (
      'GET',
      '/{siteKey}/review/initData',
      parameters,
      ['sku', ],
      ['sku', 'checkoutSiteKey', 'ssoProfileToken'],
      ['context-token', ]

    )
  }

  /**
   * Initialization data for the review form coming from RSE
   *
   * @method
   * @name ApiService#rseReviewInitData
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {string} ssoProfileToken - 
   * @param {number} lastSeenSrDate - Last seen seller rating date in milliseconds UTC
   * @param {string} checkoutSiteKey - 
   */
  rseReviewInitData(
    parameters: {
      'context-token' ? : string,
      sku: string,
      ssoProfileToken ? : string,
      lastSeenSrDate ? : number,
      checkoutSiteKey ? : string
    }
  ): Promise < ReviewInitData > {

    return call < ReviewInitData > (
      'GET',
      '/{siteKey}/review/rseInitData',
      parameters,
      ['sku', ],
      ['sku', 'ssoProfileToken', 'lastSeenSrDate', 'checkoutSiteKey'],
      ['context-token', ]

    )
  }

  /**
   * List of reviews
   *
   * @method
   * @name ApiService#reviewsList
   * @param {string} sku - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {string} filters - Encoded JSON of filters.  Example before being encoded: {"md":true,"rt":[1,2,3],"sp":[{"7":[2,3]},{"14":[1]}],"dm":[{"5":[1,4]},{"3":[2,3,4]}],"att":[{"2":[1]},{"3":[1,2]}]}
   * @param {string} sort - Default value and which options are available depends on site settings:
   * mostRecent
   * mostHelpful (formerly bestR)
   * expert (expert reviews first)
   * staff (staff reviews first)
   * topContributors (reviews first)
   * highestRated
   * lowestRated
   * mostRelevant
   * photosVideos
   * oldest
  
   * @param {boolean} includeRelated - 
   * @param {boolean} includeFilters - 
   * @param {string} searchText - 
   */
  reviewsList(
    parameters: {
      sku: string,
      offset: number,
      limit: number,
      filters: string,
      sort: "mostRecent" | "mostHelpful" | "expert" | "staff" | "topContributors" | "highestRated" | "lowestRated" | "mostRelevant" | "photosVideos" | "oldest",
      includeRelated: boolean,
      includeFilters: boolean,
      searchText ? : string
    }
  ): Promise < ReviewsListResponse > {

    return callStatic < ReviewsListResponse > (
      '/sitedata/{siteKey}/{sku}/d/review/{locale}/{offset}/{limit}/{filters}/{sort}/{includeRelated}/{includeFilters}/{searchText}',
      parameters,
      ['sku', 'offset', 'limit', 'filters', 'sort', 'includeRelated', 'includeFilters', ]
    )
  }

  /**
   * List of related reviews
   *
   * @method
   * @name ApiService#relatedReviewsList
   * @param {string} sku - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {string} sort - Default value and which options are available depends on site settings:
   * mostRecent
   * mostHelpful (formerly bestR)
   * expert (expert reviews first)
   * staff (staff reviews first)
   * topContributors (reviews first)
   * highestRated
   * lowestRated
   * mostRelevant
   * photosVideos
   * oldest
  
   */
  relatedReviewsList(
    parameters: {
      sku: string,
      offset: number,
      limit: number,
      sort: "mostRecent" | "mostHelpful" | "expert" | "staff" | "topContributors" | "highestRated" | "lowestRated" | "mostRelevant" | "photosVideos" | "oldest"
    }
  ): Promise < ReviewsListResponse > {

    return callStatic < ReviewsListResponse > (
      '/sitedata/{siteKey}/{sku}/r/relatedReview/{locale}/{offset}/{limit}/{sort}',
      parameters,
      ['sku', 'offset', 'limit', 'sort']
    )
  }

  /**
   * Spectrum of reviews
   *
   * @method
   * @name ApiService#spectrum
   * @param {string} sku - 
   */
  spectrum(
    parameters: {
      sku: string
    }
  ): Promise < SpectrumResponse > {

    return callStatic < SpectrumResponse > (
      '/sitedata/{siteKey}/{sku}/d/review/spectrum/{locale}',
      parameters,
      ['sku']
    )
  }

  /**
   * Send deviceFingerprint to be stored on the review
   *
   * @method
   * @name ApiService#saveReviewFingerprint
   * @param {string} contextToken - 
   * @param {integer} id - 
   * @param {object} body -    
   * {
   *   deviceFingerprint:string
   * }
   */
  saveReviewFingerprint(
    parameters: {
      'context-token' ? : string,
      id: number,
    },
    body: {
      deviceFingerprint ? : string
    }
  ): Promise < void > {

    return call < void > (
      'PUT',
      '/{siteKey}/review/{id}/fingerprint',
      parameters,
      ['id', ],
      [],
      ['context-token', ], body
    )
  }

  /**
   * Flag a review as inappropriate
   *
   * @method
   * @name ApiService#flagReview
   * @param {integer} id - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   */
  flagReview(
    parameters: {
      id: number,
      sku: string,
      checkoutSiteKey ? : string
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/review/{id}/flag',
      parameters,
      ['id', 'sku', ],
      ['sku', 'checkoutSiteKey'],
      []

    )
  }

  /**
   * Registers a down vote for a review
   *
   * @method
   * @name ApiService#voteForReview
   * @param {integer} id - 
   * @param {string} sku - 
   * @param {string} checkoutSiteKey - 
   * @param {object} body -    
   * {
   *   up:number
   *   down:number
   * }
   */
  voteForReview(
    parameters: {
      id: number,
      sku: string,
      checkoutSiteKey ? : string,
    },
    body: {
      up ? : number,
      down ? : number
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/review/{id}/vote',
      parameters,
      ['id', 'sku', ],
      ['sku', 'checkoutSiteKey', ],
      [], body
    )
  }

  /**
   * Get review data by id
   *
   * @method
   * @name ApiService#getReviewData
   * @param {string} originSiteKey - 
   * @param {integer} id - 
   */
  getReviewData(
    parameters: {
      originSiteKey ? : string,
      id: number
    }
  ): Promise < Review > {

    return call < Review > (
      'GET',
      '/{siteKey}/review/{id}/{locale}',
      parameters,
      ['id'],
      ['originSiteKey', ],
      []

    )
  }

  /**
   * 
   *
   * @method
   * @name ApiService#reviewsSummary
   * @param {string} sku - 
   */
  reviewsSummary(
    parameters: {
      sku: string
    }
  ): Promise < ReviewsSummaryResponse > {

    return callStatic < ReviewsSummaryResponse > (
      '/sitedata/{siteKey}/{sku}/d/review/summary/{locale}',
      parameters,
      ['sku']
    )
  }

  /**
   * This is called when coming from a successful inbox submission
   *
   * @method
   * @name ApiService#checkSellerRatingEligibile
   * @param {string} contextToken - 
   * @param {number} lastSeenSrDate - Last seen seller rating date in milliseconds UTC
   */
  checkSellerRatingEligibile(
    parameters: {
      'context-token': string,
      lastSeenSrDate ? : number
    }
  ): Promise < {
    'transactionId' ? : number
  } > {

    return call < {
      'transactionId' ? : number
    } > (
      'GET',
      '/{siteKey}/sellerRating/checkEligible',
      parameters,
      ['context-token', ],
      ['lastSeenSrDate'],
      ['context-token', ]

    )
  }

  /**
   * Save a new seller rating coming from solicitation email
   *
   * @method
   * @name ApiService#saveSellerRating
   * @param {string} contextToken - 
   * @param {string} submitType - 
   * @param {SellerRatingForm} body - 
   */
  saveSellerRating(
    parameters: {
      'context-token': string,
      submitType: "email" | "rse",
    },
    body: SellerRatingForm
  ): Promise < {
    'reviewId' ? : number
  } > {

    return call < {
      'reviewId' ? : number
    } > (
      'POST',
      '/{siteKey}/sellerRating/{submitType}',
      parameters,
      ['context-token', 'submitType', ],
      [],
      ['context-token', ], body
    )
  }

  /**
   * Initialization data for the seller rating form
   *
   * @method
   * @name ApiService#srInitData
   * @param {string} contextToken - 
   * @param {string} initType - 
   * @param {string} ssoProfileToken - 
   */
  srInitData(
    parameters: {
      'context-token' ? : string,
      initType: "srseInitData" | "initDataFromRse",
      ssoProfileToken ? : string
    }
  ): Promise < SellerRatingInitData > {

    return call < SellerRatingInitData > (
      'GET',
      '/{siteKey}/sellerRating/{initType}',
      parameters,
      ['initType', ],
      ['ssoProfileToken'],
      ['context-token', ]

    )
  }

  /**
   * Post a transaction (js feed)
   *
   * @method
   * @name ApiService#createTransaction
   * @param {CreateTransactionBody} body - 
   */
  createTransaction(
    body: CreateTransactionBody
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/transaction/{locale}', {},
      [],
      [],
      [], body
    )
  }

  /**
   * Post a transaction (js feed) and get items for user to comment on
   *
   * @method
   * @name ApiService#createTransactionAndGetItemsForComment
   * @param {CreateTransactionBody} body - 
   */
  createTransactionAndGetItemsForComment(
    body: CreateTransactionBody
  ): Promise < TransactionItemsForCommentResponse > {

    return call < TransactionItemsForCommentResponse > (
      'POST',
      '/{siteKey}/transaction/itemsForComment/{locale}', {},
      [],
      [],
      [], body
    )
  }

  /**
   * Submits user registration information
   *
   * @method
   * @name ApiService#registerUser
   * @param {string} qualifier - 
   * @param {string} registerFor - 
   * @param {RegisterUserBody} body - 
   */
  registerUser(
    parameters: {
      qualifier: string,
      registerFor: string,
    },
    body: RegisterUserBody
  ): Promise < {
    'token' ? : string,
    'ugcId' ? : number
  } > {

    return call < {
      'token' ? : string,
      'ugcId' ? : number
    } > (
      'POST',
      '/{siteKey}/user/register/{qualifier}/{registerFor}',
      parameters,
      ['qualifier', 'registerFor', ],
      [],
      [], body
    )
  }

  /**
   * Call to resend the confirmation email just sent
   *
   * @method
   * @name ApiService#resendConfirmation
   * @param {string} qualifier - 
   * @param {string} registerFor - 
   * @param {object} body -    
   * {
   *   token:string
   * }
   */
  resendConfirmation(
    parameters: {
      qualifier: string,
      registerFor: string,
    },
    body: {
      token ? : string
    }
  ): Promise < void > {

    return call < void > (
      'POST',
      '/{siteKey}/user/register/{qualifier}/resend/{registerFor}',
      parameters,
      ['qualifier', 'registerFor', ],
      [],
      [], body
    )
  }

  /**
   * Get user's reviews
   *
   * @method
   * @name ApiService#getUserReviews
   * @param {integer} id - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   */
  getUserReviews(
    parameters: {
      id: number,
      offset ? : number,
      limit ? : number
    }
  ): Promise < GetUserReviewsResponse > {

    return call < GetUserReviewsResponse > (
      'GET',
      '/{siteKey}/user/{id}/review/{locale}',
      parameters,
      ['id', ],
      ['offset', 'limit'],
      []

    )
  }

  /**
   * Get user's questions
   *
   * @method
   * @name ApiService#getUserQuestions
   * @param {integer} id - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   */
  getUserQuestions(
    parameters: {
      id: number,
      offset ? : number,
      limit ? : number
    }
  ): Promise < GetUserQuestionsResponse > {

    return call < GetUserQuestionsResponse > (
      'GET',
      '/{siteKey}/user/{id}/question/{locale}',
      parameters,
      ['id', ],
      ['offset', 'limit'],
      []

    )
  }

  /**
   * Get user's answers
   *
   * @method
   * @name ApiService#getUserAnswers
   * @param {integer} id - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   */
  getUserAnswers(
    parameters: {
      id: number,
      offset ? : number,
      limit ? : number
    }
  ): Promise < GetUserAnswersResponse > {

    return call < GetUserAnswersResponse > (
      'GET',
      '/{siteKey}/user/{id}/answer/{locale}',
      parameters,
      ['id', ],
      ['offset', 'limit'],
      []

    )
  }

  /**
   * Get user's media
   *
   * @method
   * @name ApiService#getUserMedia
   * @param {integer} id - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   */
  getUserMedia(
    parameters: {
      id: number,
      offset ? : number,
      limit ? : number
    }
  ): Promise < GetUserMediaResponse > {

    return call < GetUserMediaResponse > (
      'GET',
      '/{siteKey}/user/{id}/media/{locale}',
      parameters,
      ['id', ],
      ['offset', 'limit'],
      []

    )
  }

  /**
   * Get user's comments
   *
   * @method
   * @name ApiService#getUserComments
   * @param {integer} id - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   */
  getUserComments(
    parameters: {
      id: number,
      offset ? : number,
      limit ? : number
    }
  ): Promise < GetUserCommentsResponse > {

    return call < GetUserCommentsResponse > (
      'GET',
      '/{siteKey}/user/{id}/comment/{locale}',
      parameters,
      ['id', ],
      ['offset', 'limit'],
      []

    )
  }

  /**
   * Get statistics for user submitted ugc
   *
   * @method
   * @name ApiService#getUserUgcStats
   * @param {integer} id - 
   */
  getUserUgcStats(
    parameters: {
      id: number
    }
  ): Promise < UserUgcStats > {

    return call < UserUgcStats > (
      'GET',
      '/{siteKey}/user/{id}/ugcStats/{locale}',
      parameters,
      ['id'],
      [],
      []

    )
  }

  /**
   * Get user profile
   *
   * @method
   * @name ApiService#getUserProfile
   * @param {string} contextToken - 
   * @param {integer} id - 
   */
  getUserProfile(
    parameters: {
      'context-token': string,
      id: number
    }
  ): Promise < UserProfile > {

    return call < UserProfile > (
      'GET',
      '/{siteKey}/user/{id}/profile/{locale}',
      parameters,
      ['context-token', 'id'],
      [],
      ['context-token', ]

    )
  }

  /**
   * This can only be done by the logged in user.
   *
   * @method
   * @name ApiService#updateUserProfile
   * @param {string} contextToken - 
   * @param {integer} id - 
   * @param {UserProfile} body - 
   */
  updateUserProfile(
    parameters: {
      'context-token': string,
      id: number,
    },
    body: UserProfile
  ): Promise < UserProfile > {

    return call < UserProfile > (
      'PUT',
      '/{siteKey}/user/{id}/profile/{locale}',
      parameters,
      ['context-token', 'id', ],
      [],
      ['context-token', ], body
    )
  }

  /**
   * Get user identities by user id
   *
   * @method
   * @name ApiService#getUserIdentities
   * @param {integer} id - User id
   */
  getUserIdentities(
    parameters: {
      id: number
    }
  ): Promise < GetUserIdentitiesResponse > {

    return call < GetUserIdentitiesResponse > (
      'GET',
      '/{siteKey}/user/{id}/identity',
      parameters,
      ['id'],
      [],
      []

    )
  }

  /**
   * This can only be done by the logged in user.
   *
   * @method
   * @name ApiService#createUserIdentity
   * @param {integer} id - User id
   * @param {CreateUserIdentityBody} body - 
   */
  createUserIdentity(
    parameters: {
      id: number,
    },
    body: CreateUserIdentityBody
  ): Promise < CreateUserIdentityResponse > {

    return call < CreateUserIdentityResponse > (
      'POST',
      '/{siteKey}/user/{id}/identity',
      parameters,
      ['id', ],
      [],
      [], body
    )
  }

  /**
   * This really only updates the isPrimary property
   *
   * @method
   * @name ApiService#updateUserIdentity
   * @param {integer} id - User id
   * @param {integer} identityId - User identity id
   * @param {UpdateUserIdentityBody} body - 
   */
  updateUserIdentity(
    parameters: {
      id: number,
      identityId: number,
    },
    body: UpdateUserIdentityBody
  ): Promise < UpdateUserIdentityResponse > {

    return call < UpdateUserIdentityResponse > (
      'PUT',
      '/{siteKey}/user/{id}/identity/{identityId}',
      parameters,
      ['id', 'identityId', ],
      [],
      [], body
    )
  }

  /**
   * Delete a user identity
   *
   * @method
   * @name ApiService#deleteUserIdentity
   * @param {integer} id - User id
   * @param {integer} identityId - User identity id
   */
  deleteUserIdentity(
    parameters: {
      id: number,
      identityId: number
    }
  ): Promise < DeleteUserIdentityResponse > {

    return call < DeleteUserIdentityResponse > (
      'DELETE',
      '/{siteKey}/user/{id}/identity/{identityId}',
      parameters,
      ['id', 'identityId'],
      [],
      []

    )
  }

  /**
   * Get do more content by user id
   *
   * @method
   * @name ApiService#getDoMoreContent
   * @param {string} contextToken - 
   * @param {string} sku - 
   * @param {integer} offset - 
   * @param {integer} limit - 
   * @param {integer} questionId - 
   * @param {string} ssoProfileToken - 
   */
  getDoMoreContent(
    parameters: {
      'context-token': string,
      sku: string,
      offset ? : number,
      limit ? : number,
      questionId ? : number,
      ssoProfileToken ? : string
    }
  ): Promise < GetDoMoreContentResponse > {

    return call < GetDoMoreContentResponse > (
      'GET',
      '/{siteKey}/user/doMore/{locale}',
      parameters,
      ['context-token', 'sku', ],
      ['sku', 'offset', 'limit', 'questionId', 'ssoProfileToken'],
      ['context-token', ]

    )
  }

  /**
   * Instant answers search.
   *
   * @method
   * @name ApiService#instantAnswerSearch
   * @param {SearchBody} body - 
   */
  instantAnswerSearch(
    body: SearchBody
  ): Promise < SearchResponse > {

    return call < SearchResponse > (
      'POST',
      '/{siteKey}/answer/search', {},
      [],
      [],
      [], body
    )
  }

  /**
   * Counts for each ugc type, formally itemjs
   *
   * @method
   * @name ApiService#ugcCounts
   * @param {string} sku - 
   */
  ugcCounts(
    parameters: {
      sku: string
    }
  ): Promise < UgcCounts > {

    return call < UgcCounts > (
      'GET',
      '/sitedata/{siteKey}/{sku}/d/ugc/counts/{locale}',
      parameters,
      ['sku'],
      ['sku'],
      []

    )
  }

  /**
   * Complete action in 'ssoRegDone' js callback by partner site after sso
   *
   * @method
   * @name ApiService#completeSsoAction
   * @param {string} sku - 
   * @param {SsoRequest} body - 
   */
  completeSsoAction(
    parameters: {
      sku: string,
    },
    body: SsoRequest
  ): Promise < SsoResponse > {

    return call < SsoResponse > (
      'POST',
      '/{siteKey}/user/sso',
      parameters,
      ['sku', ],
      ['sku', ],
      [], body
    )
  }

}
export default new ApiService()


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/services/api-service.ts